import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import { Router, Location, navigate } from "@reach/router";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import data from './data.js'

import audio from './utils/audio/back-track.mp3'

import Model from './Model/Model'
import MobileModel from './MobileModel/MobileModel'
import Single from './Single/Single'
import Navigation from './Navigation/Navigation'
import Back from './Back/Back'
import Intro from './Intro/Intro'
import Canvas from './Canvas/Canvas';
import MobileCanvas from './MobileCanvas/MobileCanvas';
import MobileSingle from './MobileSingle/MobileSingle';

import isTouch from 'is-touch'

import './index.scss' 

const FadeTransitionRouter = ({ children, ...rest }) => (
  <Location>
    {({ location }) => (
      <TransitionGroup className="transition-group" component={null}>
          <CSSTransition key={location.key} classNames={location.pathname !== '/' ? 'zoom' : 'fade'} timeout={500}>
            <Router location={location} className="router">
              { children }
            </Router>
          </CSSTransition>
      </TransitionGroup>
    )}
  </Location>
);


const App = () => {

  const [ aboutVisibility, setAboutVisibility ] = React.useState(false);
  const [ isOpen, setIsOpen ] = React.useState(true);
  const [ matchQuery, setMatchQuery ] = React.useState( window.matchMedia("(min-width: 768px)").matches ? true : false )

  const audioTrack = React.useRef( null );
  const [controlAudio, setControlAudio] = React.useState( true );

  const checkQueries = () => {
    window.matchMedia("(min-width: 768px)").matches
      ? setMatchQuery( true )
      : setMatchQuery( false )
  }

  React.useEffect( () => {
    window.addEventListener( 'resize', checkQueries )
    return () => {
      window.removeEventListener( 'resize', checkQueries )
    }
  }, [ matchQuery ] )
   
  React.useEffect( () => {
    if (!isOpen) {
      if (controlAudio) {
        audioTrack.current.play()
      } else {
        audioTrack.current.pause()
      } 
    }  else {
      return null;
    }
  } , [controlAudio] )

  // Resize window
  const [ canvasScale, setCanvasScale ] = React.useState({ 
    scaleX: window.innerWidth / 640,
    scaleY: window.innerHeight / 480
  })

    function debounce(fn, ms) {
      let timer
      return _ => {
        clearTimeout(timer)
        timer = setTimeout(_ => {
          timer = null
          fn.apply(this, arguments)
        }, ms)
      };
    }

    React.useEffect(() => {
      const debouncedHandleResize = debounce(function handleResize() {
        if ((window.innerWidth / window.innerHeight) <= 1.3 ) {
            setCanvasScale({
              scaleX: (((window.innerHeight / 480) / 3) * 4),
              scaleY: window.innerHeight / 480
            })
        } else {
            setCanvasScale({
              scaleX: window.innerWidth / 640,
              scaleY: (((window.innerWidth / 640) / 4) * 3)
            })
        }

      }, 1000)
  
      window.addEventListener('resize', debouncedHandleResize)
  
      return _ => {
        window.removeEventListener('resize', debouncedHandleResize)
      }
    }, [ window.innerWidth, window.innerHeight ])

    const [isLoading, setIsLoading] = React.useState( true )

    React.useEffect( () => {
      let loading = null;
        loading = setTimeout( () => setIsLoading(false), 700 );
        return function cleanup() {
            clearTimeout( loading );
        }
    }, [] )

/*
    Lock Landscape
*/
    const [isLandscape, setIsLandscape] = React.useState(false)

    React.useEffect( () => {
      if (isTouch) {
        if (window.innerWidth > window.innerHeight) {
          console.log('landscape')
          setIsLandscape(true)
        console.log(isLandscape)
        } else if (window.innerWidth < window.innerHeight ) {
          console.log('portrait')
          setIsLandscape(false)
        console.log(isLandscape)
        }
      } else {
        console.log('is Desktop')
      }

    }, [canvasScale] )






  return (
      <>
        <div className={`landscapeAdvise${ isLandscape && `--visible` }` } > </div>
        <div className={`loadpage${ !isLoading && `--hidden` }` } style={{ height: '100%', width:'100%', background: 'black', position: 'absolute', transition:' all 600ms ease-in', zIndex:`9999` }} > </div>

        <Intro data={ data } isOpen={ isOpen } onClick={ () => [setIsOpen(false), audioTrack.current.play() ] } matchQuery={matchQuery} />
        <FadeTransitionRouter>
          {
            matchQuery || !isTouch
              ? <Model aboutVisibility={ aboutVisibility } setAboutVisibility={ setAboutVisibility } controlAudio={controlAudio} setControlAudio={setControlAudio} isOpen={ isOpen } data={ data } path="/" />
              : <MobileModel aboutVisibility={ aboutVisibility } setAboutVisibility={ setAboutVisibility } controlAudio={controlAudio} setControlAudio={setControlAudio} isOpen={ isOpen } data={ data } path="/" />
          }

          {
            window.matchMedia("(min-width: 1024px)").matches
              ? <Single data={ data } isOpen={isOpen} setIsOpen={setIsOpen} controlAudio={controlAudio} setControlAudio={setControlAudio} path=":slug/" />
              : <MobileSingle data={ data } isOpen={isOpen} setIsOpen={setIsOpen} controlAudio={controlAudio} setControlAudio={setControlAudio} path=":slug/" />
          }
            
        </FadeTransitionRouter>
        
          {
            matchQuery || !isTouch
              ? <Canvas opaque={ !aboutVisibility } isOpen={isOpen} canvasScale={canvasScale} setCanvasScale={setCanvasScale}/>
              : <MobileCanvas opaque={ !aboutVisibility } isOpen={isOpen} canvasScale={canvasScale} setCanvasScale={setCanvasScale}/>
          }

        <audio src={audio} ref={ audioTrack } loop />

      </>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
